import "../assets/css/theme.css";
import { Link } from "react-router-dom";
import { BsCheckCircleFill } from "react-icons/bs";
import { useState, useEffect } from "react";

export default function Categories() {
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  function getCategoriesWithTypes() {
    setLoading(true);

    fetch(`https://api.domehelp.com/ProductInformation/GetJobTypes`, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          console.log("Error fetching categories");
          return;
        }
        return response.json();
      })
      .then((result) => {
        if (result.status === 1) {
          console.log(result);
          setCategoryTypes(result.data);
        } else {
          setCategoryTypes([]);
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getCategoriesWithTypes();
  }, []);

  return loading ? (
    <div className="text-center py-5">
      <div className="spinner-border text-primary"></div>
    </div>
  ) : (
    <section className="categories-section">
      <div className="container-fluid px-5">
        <div className="category-section-heading">
          <span>140+ Verified Categories</span>

          <h2>Browse Our Premium Databases</h2>

          <p>
            Explore verified B2B and B2C databases across industries,
            professionals and locations.
          </p>
        </div>

        <div className="category-grid">
          {categoryTypes.map((category) => (
            <div className="category-card" key={category.id}>
              <div className="category-card-header text-center">
                <h5 className="text-white">{category.title}</h5>
              </div>

              <div className="category-card-body">
                {category.item?.slice(0, 6).map((item, index) => (
                  <Link
                    to={`/ProductDetails/${item.catId}`}
                    className="category-item"
                    title={item.catName}
                  >
                    <BsCheckCircleFill />
                    <span>{item.catName}</span>
                  </Link>
                ))}
              </div>

              <Link
                to={`/Products?Cat=${category.id}`}
                className="category-view-btn"
              >
                 View All ({category.item.length})
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
